import { render } from "./Checkbox.vue?vue&type=template&id=415459e8"
import script from "./Checkbox.vue?vue&type=script&lang=js"
export * from "./Checkbox.vue?vue&type=script&lang=js"

import exportComponent from "/home/caknaummah-console/webapps/caknaummah-console/releases/1793606032358/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__